import { css } from '@emotion/core';
import { variables, tokens, shadow } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors,
  shadows = tokens.shadows;
export var container = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;position:absolute;right:calc(40px + 5%);bottom:0;width:320px;min-height:auto;border-radius:2px;background-color:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";vertical-align:top;box-shadow:", shadow(shadows.elevation2), ";padding:24px;overflow:hidden;");
export var topSection = /*#__PURE__*/css("font-size:", font.h3FontSize, ";white-space:nowrap;margin-bottom:26px;");
export var leftSection = {
  name: "v7ibj3",
  styles: "display:inline-block;vertical-align:middle;"
};
export var avatar = {
  name: "vldkxt",
  styles: "width:56px;height:56px;"
};
export var rightSection = {
  name: "8rzxrx",
  styles: "display:inline-block;margin-left:15px;margin-right:10px;font-size:22px;vertical-align:middle;white-space:normal;max-width:190px;"
};
export var name = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";line-height:24px;");
export var jobTitle = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";line-height:20px;");
export var middleContainer = {
  name: "52pg05",
  styles: "padding-bottom:31px;"
};
export var agencyName = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";line-height:24px;color:", colors.neutral.heavy.default, ";");
export var bottomSectionContainer = {
  name: "ecvpot",
  styles: "display:flex;flex-direction:column;justify-content:end;width:100%;"
};
export var bottomSection = {
  name: "18lrmmd",
  styles: "white-space:nowrap;display:flex;gap:12px;align-items:center;justify-content:space-between;width:100%;max-width:100%;"
};
export var callButton = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");
export var emailButton = {
  name: "1rr4qq7",
  styles: "flex:1;"
};